import { useEffect, useState } from 'react'
import { useLocation,useNavigate } from 'react-router-dom'
import {HiOutlineBuildingOffice} from 'react-icons/hi2';
import {RiListCheck} from 'react-icons/ri';
import {AiOutlineControl,AiOutlineUserAdd} from 'react-icons/ai';
import { useSelector } from 'react-redux';
import { TbMoneybag } from "react-icons/tb";
import { FiRepeat } from "react-icons/fi";
import { FaWhatsapp } from "react-icons/fa";
import { MdOutlineTimer } from "react-icons/md";
import { LuLayoutTemplate } from "react-icons/lu";
import { RiHomeOfficeLine } from "react-icons/ri";
import { AiOutlineFileExcel } from "react-icons/ai";
import { TbBrandCampaignmonitor } from "react-icons/tb";
import { IoFilterCircleOutline } from "react-icons/io5";
import { PiTargetBold } from "react-icons/pi";
import { TbPhoneCall } from "react-icons/tb";
import { PiChatTeardropDots } from "react-icons/pi";
import { CgFormatStrike } from "react-icons/cg";
import { BiMessageAltDetail } from "react-icons/bi";
import { CgWebsite } from "react-icons/cg";
import { TiMessage } from "react-icons/ti";
import { FaChalkboardTeacher } from "react-icons/fa";
import { TbBrandBooking } from "react-icons/tb";
import { HiOutlineClipboardList } from "react-icons/hi";
import { BsSmartwatch } from "react-icons/bs";
import { AiOutlineSchedule } from "react-icons/ai";
import { BiCameraHome } from "react-icons/bi";
import { MdEmojiFlags } from "react-icons/md";
import { MdBatchPrediction } from "react-icons/md";
import { MdOutlineGroupWork } from "react-icons/md";
import { FaChalkboard } from "react-icons/fa";
import { MdOutlineViewStream } from "react-icons/md";
import { MdOutlineSubject } from "react-icons/md";
import { RiFileExcel2Line } from "react-icons/ri";
import { MdCardMembership } from "react-icons/md";
import { TbLayoutDistributeHorizontal } from "react-icons/tb";
import { LuAlignVerticalDistributeCenter } from "react-icons/lu";
import { MdOutlineRateReview } from "react-icons/md";
import { LuUngroup } from "react-icons/lu";
import { GrCapacity } from "react-icons/gr";

function SettingsMenu() {

  const {pathname} = useLocation()

  const [step,setstep] = useState(1)
  const navigator = useNavigate()
  const roles = useSelector(state=>state.Auth.roles)
  

 

  const menu1 = [
    {name:'Our Department',icon:HiOutlineBuildingOffice,path:'/settings/department',id:1,color:''},
    {name:'Our Designation',icon:RiListCheck,path:'/settings/designation',id:1,color:''},
    {name:'Our Roles',icon:AiOutlineControl,path:'/settings/roles',id:2,color:''},
  ] 


  const menu3 = [
    {name:'OnBoard Employee',icon:AiOutlineUserAdd,path:'/settings/onboard_list',id:1,color:''},
  ]

  const menu4 = [
    {name:'FollowUp Template',icon:FiRepeat,path:'/settings/followup_list',id:1,color:''},
    {name:'ReTarget Customer',icon:PiTargetBold,path:'/settings/retarget_customer',id:1,color:''},
    {name:'Filter Standard',icon:IoFilterCircleOutline,path:'/settings/filter_standard',id:1,color:''},
    {name:'Subscription Points',icon:TbMoneybag,path:'/settings/subscription_point',id:2,color:''},
    {name:'Distributor Subscription Points',icon:LuAlignVerticalDistributeCenter,path:'/settings/distribution_subscription_point',id:4,color:''},
    {name:'Client Assign Time',icon:MdOutlineTimer,path:'/settings/client_assign_time',id:3,color:''},
    {name:'WFH Emp Option',icon:RiHomeOfficeLine,path:'/settings/work_from_employee_option',id:4,color:''},
    {name:'Client Excel',icon:AiOutlineFileExcel,path:'/settings/client_excel_upload',id:5,color:''},
    {name:'Teacher Client Excel',icon:RiFileExcel2Line,path:'/settings/teacher_client_excel_upload',id:5,color:''},
    {name:'VoiceCall List',icon:TbPhoneCall,path:'/settings/voice_call_list',id:6,color:''},
    {name:'Message Target List',icon:BiMessageAltDetail,path:'/settings/message_target_list',id:6,color:''},
    {name:'City List',icon:GrCapacity,path:'/settings/city_list',id:6,color:''},
  ]

  const menu5 = [
    {name:'Welcome Message',icon:TiMessage,path:'/settings/welcome_message_list',id:1,color:''},
    {name:'Meta Message',icon:TbBrandCampaignmonitor,path:'/settings/meta_message_list',id:1,color:''},
    {name:'Wati Message',icon:FaWhatsapp,path:'/settings/wati_message_list',id:2,color:''},
    {name:'Wati Template',icon:LuLayoutTemplate,path:'/settings/wati_template_list',id:3,color:''},
    {name:'Chat Result',icon:PiChatTeardropDots,path:'/settings/get_chat_success',id:4,color:''},
    {name:'Template Message',icon:CgFormatStrike,path:'/settings/template',id:5,color:''},
    {name:'Website Message',icon:CgWebsite,path:'/settings/website_option',id:5,color:''},
  ]

  const menu6 = [
    {name:'Teacher List',icon:FaChalkboardTeacher,path:'/settings/teacher_list',id:1,color:''},
    {name:'Distributor List',icon:TbLayoutDistributeHorizontal,path:'/settings/distributor_list',id:1,color:''},
    {name:'Digital Card List',icon:TbLayoutDistributeHorizontal,path:'/settings/digital_card',id:1,color:''},
    {name:'Data Assign Count',icon:TbBrandBooking,path:'/settings/booking_count_assign',id:2,color:''},
    {name:'Booking Slot',icon:BsSmartwatch,path:'/settings/booking_slot',id:3,color:''},
    {name:'Batches Slot',icon:AiOutlineSchedule,path:'/settings/batches_slot',id:3,color:''},
    {name:'Subscription Plan',icon:HiOutlineClipboardList,path:'/settings/personal_training_subscription',id:4,color:''},
    {name:'Home Page Data',icon:BiCameraHome,path:'/settings/class_home_page_data',id:4,color:''},
    {name:'Franchise Request',icon:MdCardMembership,path:'/settings/franchise_request',id:7,color:''},
    {name:'Link Model',icon:HiOutlineClipboardList,path:'/settings/current_link_model',id:10,color:''},
    {name:'Parent Feedback',icon:MdOutlineRateReview,path:'/settings/parent_feedback',id:11,color:''},
  ]

  const menu7 = [
    {name:'Demo Booking',icon:MdEmojiFlags,path:'/settings/demo_booking_list',id:1,color:''},
    {name:'Batch Subscription',icon:MdBatchPrediction,path:'/settings/batch_subscription_list',id:2,color:''},
    {name:'All Booking Req',icon:MdOutlineGroupWork,path:'/settings/all_booking_req',id:3,color:''},
  ]

  const menu8 = [
    {name:'Student Syllabus',icon:FaChalkboard,path:'/settings/student_board',id:1,color:''},
    // {name:'Student Stream',icon:MdOutlineViewStream,path:'/settings/student_stream',id:2,color:''},
    // {name:'Student Subject',icon:MdOutlineSubject,path:'/settings/student_subject',id:3,color:''},
    {name:'Subject List',icon:MdOutlineSubject,path:'/settings/subject',id:4,color:''},
    {name:'Chapter List',icon:HiOutlineClipboardList,path:'/settings/chapter',id:5,color:''},
  ]

   const menu9 = [
    {name:'Class Room',icon:LuUngroup,path:'/settings/class_room',id:1,color:''},
   ]

  

  

  
  const menuGroups = [
    {title:'Basic Options', items:menu1},
    {title:'Controller Options', items:menu3},
    {title:'Admin Options', items:menu4},
    {title:'Wati Options', items:menu5},
    {title:'MyAcademy Options', items:menu6},
    {title:'CBS Options', items:menu7},
    {title:'Student Additional Options', items:menu8},
    {title:'Offline Class Options', items:menu9},
  ]

  useEffect(()=>{
    const activeIndex = menuGroups.findIndex((g)=>g.items?.some((f)=>f.path === pathname))
    setstep(activeIndex >= 0 ? activeIndex + 1 : 1)
  },[])


  


  


  

  return (
    <div className='md:min-h-screen md:min-w-[170px] md:max-w-[170px] md:max-h-screen overflow-y-scroll overflow-x-hidden border-r pb-10'>

        <div className='flex md:hidden mx-3 mt-3 items-center overflow-x-auto whitespace-nowrap pb-1'>
          {menuGroups.map((g, gi) => (
            <div key={g.title} onClick={()=>setstep(gi+1)} className='relative cursor-pointer mr-2 flex-shrink-0'>
              <h6 className={`rounded-md px-2 py-1.5 font-[500] ${step === gi+1 && 'bg-[#f4f5f7]'} text-[12px]`}>{g.title}</h6>
              {step === gi+1 && <span className='border-slate-800 border-2 h-6 rounded absolute -ml-1.5 top-0' ></span>}
            </div>
          ))}
        </div>

        <div className='block md:hidden mb-4 mx-3 pt-2'>
            <div className='flex flex-wrap w-auto'>
            {menuGroups[step-1]?.items.map((m)=>(
                <div key={m?.path} className={`flex pr-4 items-center my-1 hover:bg-[#f4f5f7] px-1.5 py-1.5 rounded-md relative cursor-pointer ${pathname ===  m.path && 'bg-[#f4f5f7]'}`} onClick={()=>navigator(m?.path)}>
                {pathname ===  m.path &&  <span className='border-slate-800 border-2 h-6 rounded absolute -ml-3' ></span>}
               <m.icon color='#000' style={{backgroundColor:m?.color,padding:'2px'}} size={16}  />
               <span className='text-[#000] font-[400] ml-2 text-[12px]'>{m.name}</span>
              </div>
            ))}
            </div>
        </div>


      <div className='hidden md:block mr-0 md:min-h-screen md:max-h-screen md:border-r  md:w-44 px-2'>
           

          <h1 className='hidden md:block ml-2 mb-2 font-[700] text-[12px] pt-3 mt-2'> Basic Options</h1>
           {menu1.map((m)=>(
                <div key={m?.path} className={`flex items-center my-1 hover:bg-[#f4f5f7] px-1.5 py-1 ml-2 rounded-md relative cursor-pointer ${pathname ===  m.path && 'bg-[#f4f5f7]'}`} onClick={()=>navigator(m?.path)}>
                {pathname ===  m.path &&  <span className='border-slate-800 border-2 h-6 rounded absolute -ml-3' ></span>}
               <m.icon color='#000' style={{backgroundColor:m?.color,padding:'2px'}} size={16}  />
               <span className='text-[#000] font-[400] ml-2 text-[12px]'>{m.name}</span>
              </div>    
            ))}


           <h1 className='hidden md:block ml-2 mb-2 font-[700] text-[12px] pt-3 border-t'>Controller Options</h1>
           {menu3.map((m)=>(
                <div key={m?.path} className={`flex items-center my-1 hover:bg-[#f4f5f7] px-1.5 py-1 ml-2 rounded-md relative cursor-pointer ${pathname ===  m.path && 'bg-[#f4f5f7]'}`} onClick={()=>navigator(m?.path)}>
                {pathname ===  m.path &&  <span className='border-slate-800 border-2 h-6 rounded absolute -ml-3' ></span>}
               <m.icon color='#000' style={{backgroundColor:m?.color,padding:'2px'}} size={16}  />
               <span className='text-[#000] font-[400] ml-2 text-[12px]'>{m.name}</span>
              </div>    
            ))} 

            {/* {(['admin']?.filter((f)=>roles?.includes(f))?.length > 0 && */}
            <>
            <h1 className='hidden md:block ml-2 mb-2 font-[700] text-[12px] pt-3 border-t'>Admin Options</h1>
            {menu4.map((m)=>(
                <div key={m?.path} className={`flex items-center my-1 hover:bg-[#f4f5f7] px-1.5 py-1 ml-2 rounded-md relative cursor-pointer ${pathname ===  m.path && 'bg-[#f4f5f7]'}`} onClick={()=>navigator(m?.path)}>
                {pathname ===  m.path &&  <span className='border-slate-800 border-2 h-6 rounded absolute -ml-3' ></span>}
               <m.icon color='#000' style={{backgroundColor:m?.color,padding:'2px'}} size={16}  />
               <span className='text-[#000] font-[400] ml-2 text-[12px]'>{m.name}</span>
              </div>    
            ))} 
            </>

            <>
            <h1 className='hidden md:block ml-2 mb-2 font-[700] text-[12px] pt-3 border-t'>Wati Options</h1>
            {menu5.map((m)=>(
                <div key={m?.path} className={`flex items-center my-1 hover:bg-[#f4f5f7] px-1.5 py-1 ml-2 rounded-md relative cursor-pointer ${pathname ===  m.path && 'bg-[#f4f5f7]'}`} onClick={()=>navigator(m?.path)}>
                {pathname ===  m.path &&  <span className='border-slate-800 border-2 h-6 rounded absolute -ml-3' ></span>}
               <m.icon color='#000' style={{backgroundColor:m?.color,padding:'2px'}} size={16}  />
               <span className='text-[#000] font-[400] ml-2 text-[12px]'>{m.name}</span>
              </div>    
            ))} 
            </>

            <>
            <h1 className='hidden md:block ml-2 mb-2 font-[700] text-[12px] pt-3 border-t'>MyAcademy Options</h1>
            {menu6.map((m)=>(
                <div key={m?.path} className={`flex items-center my-1 hover:bg-[#f4f5f7] px-1.5 py-1 ml-2 rounded-md relative cursor-pointer ${pathname ===  m.path && 'bg-[#f4f5f7]'}`} onClick={()=>navigator(m?.path)}>
                {pathname ===  m.path &&  <span className='border-slate-800 border-2 h-6 rounded absolute -ml-3' ></span>}
               <m.icon color='#000' style={{backgroundColor:m?.color,padding:'2px'}} size={16}  />
               <span className='text-[#000] font-[400] ml-2 text-[12px]'>{m.name}</span>
              </div>    
            ))} 
            </>

             <>
            <h1 className='hidden md:block ml-2 mb-2 font-[700] text-[12px] pt-3 border-t'>CBS Options</h1>
            {menu7.map((m)=>(
                <div key={m?.path} className={`flex items-center my-1 hover:bg-[#f4f5f7] px-1.5 py-1 ml-2 rounded-md relative cursor-pointer ${pathname ===  m.path && 'bg-[#f4f5f7]'}`} onClick={()=>navigator(m?.path)}>
                {pathname ===  m.path &&  <span className='border-slate-800 border-2 h-6 rounded absolute -ml-3' ></span>}
               <m.icon color='#000' style={{backgroundColor:m?.color,padding:'2px'}} size={16}  />
               <span className='text-[#000] font-[400] ml-2 text-[12px]'>{m.name}</span>
              </div>    
            ))} 
            </>

               <>
            <h1 className='hidden md:block ml-2 mb-2 font-[700] text-[12px] pt-3 border-t'>Student Additional Options</h1>
            {menu8.map((m)=>(
                <div key={m?.path} className={`flex items-center my-1 hover:bg-[#f4f5f7] px-1.5 py-1 ml-2 rounded-md relative cursor-pointer ${pathname ===  m.path && 'bg-[#f4f5f7]'}`} onClick={()=>navigator(m?.path)}>
                {pathname ===  m.path &&  <span className='border-slate-800 border-2 h-6 rounded absolute -ml-3' ></span>}
               <m.icon color='#000' style={{backgroundColor:m?.color,padding:'2px'}} size={16}  />
               <span className='text-[#000] font-[400] ml-2 text-[12px]'>{m.name}</span>
              </div>    
            ))} 
            </>


     <>
            <h1 className='hidden md:block ml-2 mb-2 font-[700] text-[12px] pt-3 border-t'>Offline Class Options</h1>
            {menu9.map((m)=>(
                <div key={m?.path} className={`flex items-center my-1 hover:bg-[#f4f5f7] px-1.5 py-1 ml-2 rounded-md relative cursor-pointer ${pathname ===  m.path && 'bg-[#f4f5f7]'}`} onClick={()=>navigator(m?.path)}>
                {pathname ===  m.path &&  <span className='border-slate-800 border-2 h-6 rounded absolute -ml-3' ></span>}
               <m.icon color='#000' style={{backgroundColor:m?.color,padding:'2px'}} size={16}  />
               <span className='text-[#000] font-[400] ml-2 text-[12px]'>{m.name}</span>
              </div>    
            ))} 
            </>

            
            {/* )}   */}

           

       
      </div>

     

   
    </div>
  )
}

export default SettingsMenu